import {SELECT_VIEW} from './settings/constants';
import {selectViewFunction} from '../../moduls/utils';
import {Component} from 'preact';

export default class WidgetComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {data: this.props.data, progress: this.props.progress};
  }

  render() {
    const Layout = selectViewFunction({layout: `compact`}, SELECT_VIEW);
    return (
      <Layout {...this.state} />
    );
  }
};



// WEBPACK FOOTER //
// ./components/widget/index.js